export default {
  productType: null,
  plan: {
    type: null,
    name: null,
    currency: null,
    duration: null,
    link: null,
    loginPath: null,
    signupPath: null,
    price: {
      final: null,
      perMonth: null,
      original: null
    },
    freeMarkup: null,
    trialDays: null
  },
  countryCode: null,
  tosPath: null,
  showThreeDs: false,
  coupon: {
    loading: false,
    code: null,
    value: null,
    error: null,
    type: null
  },
  selectedPaymentMethod: null,
  tax: {
    amount: null,
    region: null
  },
  zip: {
    loading: false,
    error: null,
    value: null
  },
  giftcard: {
    recipientName: "",
    message: "",
    receiver: {
      type: "gifter",
      email: ""
    }
  },
  loading: false,
  sending: false,
  error: null,
  countryOptions: null,
  isIosAppPurchase: false,
  isInVariation: false
};
